import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '/api' 
  : 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Songs API
export const getSongs = async () => {
  const response = await api.get('/songs');
  return response.data;
};

export const getSong = async (id) => {
  const response = await api.get(`/songs/${id}`);
  return response.data;
};

export const createSong = async (songData) => {
  const response = await api.post('/songs', songData);
  return response.data;
};

export const updateSong = async (id, songData) => {
  const response = await api.put(`/songs/${id}`, songData);
  return response.data;
};

export const deleteSong = async (id) => {
  const response = await api.delete(`/songs/${id}`);
  return response.data;
};

export default api;